import React, { useEffect, useMemo, useState } from "react";
import ExtensionInputGroup, { StyledLabel, StyledToggleLabel } from "./ExtensionInputGroup";
import { useExtensionContext } from "../ExtensionContext";
import styled from "styled-components";
import { DEAL_WON, dealChannelTypesOptions, dealMarketingTypesOptions, TOGGLE_OPTIONS } from "../utils/constants";
import Toggle from "app/popleads/components/ui-kit/Toggle";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import moment from "moment";
import useActivityPreview from "app/popleads/hooks/useActivityPreview";
import ButtonWithLabel from "app/popleads/components/ui-kit/ButtonWithLabel";
import { StyledItemContainer } from "./ExtensionViewDeal";
import { colors } from "app/popleads/components/ui-kit/colors";
import { useSelector } from "react-redux";
import ExtensionDealAttachments from "./ExtensionDealAttachments";

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

const ExtensionConsultingDeal = ({ dealObject, setDealObject, validateField }) => {
    const { companyUsers, profile, initialDealObject } = useExtensionContext();
    const { user: loggedInUser } = useSelector((state) => state.auth);
    const [emptyInhouseInquiries, setEmptyInhouseInquiries] = useState(false);

    const existInquiries = useMemo(() => {
        return (
            profile?.olanak
                ?.filter((item) => {
                    return (
                        (item.activityType === "Consulting Services" && dealObject.dealCampaignType === "Consulting") ||
                        (item.activityType === "Coaching Inquiry" && dealObject.dealCampaignType === "Coaching") ||
                        (item.activityType === "eLearning Inquiry" &&
                            (dealObject.dealCampaignType === "E-Learning" ||
                                dealObject.dealCampaignType === "EdTech") &&
                            item.kayitciId === loggedInUser.id)
                    );
                })
                .map((item) => ({
                    label: item.activityName,
                    value: item.activityId,
                })) || []
        );
    }, [profile, dealObject.dealCampaignType, loggedInUser.id]);

    useEffect(() => {
        if (existInquiries.length === 0) {
            setDealObject({ ...dealObject, selectedInquiry: null, newInquiry: true });
            setEmptyInhouseInquiries(true);
        } else {
            setDealObject({ ...dealObject, selectedInquiry: null, newInquiry: false });
            setEmptyInhouseInquiries(false);
        }
    }, [existInquiries]);

    const handleInputChange = (field, value) => {
        if (validateField(field, value)) {
            setDealObject({ ...dealObject, [field]: value });
        } else if (field === "closingDate") {
            setDealObject({ ...dealObject, closingDate: value });
        }
    };

    useEffect(() => {
        if (!dealObject.partner) {
            const partnerUserId = companyUsers?.find((item) => item.name === dealObject.partnerName)?.id;
            if (partnerUserId) {
                setDealObject({ ...dealObject, partner: dealObject.partnerName, partnerUserId: partnerUserId });
            }
        }
    }, [dealObject, companyUsers]);

    const { getActivityPreview } = useActivityPreview();
    const [activityPreview, setActivityPreview] = useState(null);

    useEffect(() => {
        if (dealObject.activityId) {
            getActivityPreview(dealObject.activityId).then((data) => {
                setActivityPreview(data.activity);
            });
        }
    }, [dealObject.activityId]);

    let courseNameLabel = "";
    let newCourseNameLabel = "";
    if (dealObject.dealCampaignType === "E-Learning" || dealObject.dealCampaignType === "EdTech") {
        courseNameLabel = "E-Learning Bundles";
        newCourseNameLabel = "New E-Learning Bundles";
    } else if (dealObject.dealCampaignType === "Consulting") {
        courseNameLabel = "Type of Consulting";
        newCourseNameLabel = "New Consulting Type";
    } else if (dealObject.dealCampaignType === "Coaching") {
        courseNameLabel = "Type of Coaching";
        newCourseNameLabel = "New Coaching Type";
    }
    const courseNameOptions = [
        ...(activityPreview?.topicList || []).map((item) => ({
            label: item.topicName,
            value: item.topicName,
        })),
        { label: "Type a new " + courseNameLabel, value: "newCourseName" },
    ];

    const formatAmount = (amount) => {
        return Number(amount) % 1 === 0 ? Math.floor(amount) : amount;
    };

    useEffect(() => {
        if (!dealObject.selectedInquiry) return;

        const inquiry = profile.olanak.find((item) => item.activityId === dealObject.selectedInquiry);
        const partnerUserId = companyUsers?.find((item) => item.name === inquiry?.partnerName)?.id;
        if (inquiry) {
            const fieldUpdates = {
                selectedInquiry: inquiry,
                ad: inquiry.ad,
                accountName: inquiry.accountName,
                amount: formatAmount(inquiry.amount),
                closingDate: inquiry.kapanmaTarihi,
                type: inquiry.type,
                channelType: inquiry.dealTypeChannel,
                partnerName: inquiry.partnerName,
                partner: partnerUserId,
                partnerUserId: partnerUserId,
                vatIncludes: inquiry.vatIncludes === 1 ? "Yes" : "No",
                paid: inquiry.paid === 1 ? "Yes" : "No",
                courseName: inquiry.courseName,
                newCourseName: null,
            };

            getActivityPreview(inquiry.activityId).then((data) => {
                setActivityPreview(data.activity);
            });

            setDealObject((prev) => ({
                ...prev,
                ...fieldUpdates,
            }));
        }
    }, [dealObject.selectedInquiry, companyUsers]);

    return (
        <StyledContainer>
            {/* 1. senaryo activityID yok. started */}
            {!dealObject.activityId && (
                <>
                    {/* activityId yok, yeni deal oluşturulacak. */}
                    {/* newInquiry */}
                    {!emptyInhouseInquiries && (
                        <ExtensionInputGroup
                            variant="l3rnTech"
                            label="Select Existing Inquiry"
                            type="select"
                            options={existInquiries ?? []}
                            disabled={dealObject.newInquiry}
                            value={
                                dealObject.selectedInquiry
                                    ? {
                                          label: dealObject.selectedInquiry.activityName,
                                          value: dealObject.selectedInquiry.activityId,
                                      }
                                    : ""
                            }
                            onChange={(selected) => {
                                handleInputChange("selectedInquiry", selected.value);
                                setDealObject({ ...dealObject, selectedInquiry: selected.value, newInquiry: false });
                            }}
                            placeholder="Select Existing Inquiry"
                        />
                    )}
                    {/* 1.1: newInquiry false: mevcut deal seçilecek. */}
                    {!dealObject.newInquiry && (
                        <>
                            {/* newInquiry false: mevcut deal seçilecek. */}
                            {dealObject.selectedInquiry && (
                                <>
                                    {/* dealObject.selectedInquiry var */}
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Deal Name"
                                        type="input"
                                        inpType="text"
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("ad", value);
                                        }}
                                        value={dealObject.ad}
                                        placeholder="Enter Deal Name"
                                    />{" "}
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label={courseNameLabel}
                                        type="select"
                                        inpType="text"
                                        onChange={(selected) => {
                                            handleInputChange("courseName", selected.value);
                                        }}
                                        options={courseNameOptions}
                                        value={
                                            dealObject.courseName
                                                ? dealObject.courseName === "newCourseName"
                                                    ? { label: "Type a new " + courseNameLabel, value: "newCourseName" }
                                                    : { label: dealObject.courseName, value: dealObject.courseName }
                                                : ""
                                        }
                                        placeholder={`Select ${courseNameLabel}`}
                                    />
                                    {dealObject?.courseName === "newCourseName" && (
                                        <ExtensionInputGroup
                                            variant="l3rnTech"
                                            label={`New ${courseNameLabel}`}
                                            type="input"
                                            inpType="text"
                                            onChange={(e) => {
                                                const value = e.target ? e.target.value : e;
                                                handleInputChange("newCourseName", value);
                                            }}
                                            value={dealObject.newCourseName}
                                            placeholder={`Enter ${newCourseNameLabel}`}
                                        />
                                    )}
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Account Name"
                                        type="input"
                                        inpType="text"
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("accountName", value);
                                        }}
                                        value={dealObject.accountName}
                                        placeholder="Enter Account Name"
                                    />
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Unit Amount USD"
                                        type="input"
                                        inpType="number"
                                        leftIcon="dollar-sign"
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("amount", value);
                                        }}
                                        value={dealObject.amount}
                                        placeholder="Enter Unit Amount"
                                    />
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Set Closing Date"
                                        type="date"
                                        onChange={(date) => {
                                            handleInputChange("closingDate", date);
                                        }}
                                        value={dealObject.closingDate}
                                        placeholder="Select Closing Date"
                                        dateFormat={"dd/MM/yyyy"}
                                    />
                                    <StyledItemContainer marginBottom="0">
                                        <StyledToggleLabel color={colors.neutral[900]}>Paid</StyledToggleLabel>
                                        <Toggle
                                            variant="l3rnTech"
                                            setSelected={(value) => {
                                                handleInputChange("paid", value);
                                            }}
                                            selected={dealObject.paid}
                                            options={TOGGLE_OPTIONS}
                                        />
                                    </StyledItemContainer>
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Type"
                                        type="select"
                                        options={dealMarketingTypesOptions}
                                        value={
                                            dealObject.type ? { label: dealObject.type, value: dealObject.type } : ""
                                        }
                                        onChange={(selected) => {
                                            handleInputChange("type", selected.value);
                                        }}
                                        placeholder="Select Type"
                                    />
                                    {(dealObject.type === "Marketing" ||
                                        dealObject.type === "Marketing Cross Sale") && (
                                        <ExtensionInputGroup
                                            variant="l3rnTech"
                                            label="Select Marketing Channel"
                                            type="select"
                                            options={dealChannelTypesOptions}
                                            value={
                                                dealObject.channelType
                                                    ? { label: dealObject.channelType, value: dealObject.channelType }
                                                    : ""
                                            }
                                            onChange={(selected) => {
                                                handleInputChange("channelType", selected.value);
                                            }}
                                            placeholder="Select Marketing Channel"
                                        />
                                    )}
                                    {dealObject.type === "Re-Seller Partnership" && (
                                        <ExtensionInputGroup
                                            label="End User"
                                            type="input"
                                            inpType="text"
                                            onChange={(e) => {
                                                const value = e.target ? e.target.value : e;
                                                handleInputChange("endUser", value);
                                            }}
                                            value={dealObject.endUser}
                                            placeholder="Please enter end user"
                                            minLength={1}
                                            variant="l3rnTech"
                                        />
                                    )}
                                    {dealObject.dealCampaignType === "L&D Broker" && (
                                        <>
                                            <ExtensionInputGroup
                                                label="Amount for Vendor Payment"
                                                type="input"
                                                inpType="number"
                                                leftIcon="dollar-sign"
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const value = e.target ? e.target.value : e;
                                                    handleInputChange("vendorPaymentAmount", value);
                                                }}
                                                value={dealObject.vendorPaymentAmount}
                                                minLength={1}
                                                placeholder="Enter amount for vendor payment"
                                                variant="l3rnTech"
                                            />
                                            <ExtensionInputGroup
                                                label="Margin amount for LEORON"
                                                type="input"
                                                inpType="number"
                                                leftIcon="dollar-sign"
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    const value = e.target ? e.target.value : e;
                                                    handleInputChange("leoronMarginAmount", value);
                                                }}
                                                value={dealObject.leoronMarginAmount}
                                                minLength={1}
                                                placeholder="Enter margin amount for LEORON"
                                                variant="l3rnTech"
                                            />
                                        </>
                                    )}
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Partner"
                                        type="select"
                                        loadOptions={(input, callback) =>
                                            callback(
                                                companyUsers
                                                    .filter((user) =>
                                                        user.name.toLowerCase().includes(input.toLowerCase())
                                                    )
                                                    .map((item) => {
                                                        return {
                                                            label: item.name,
                                                            value: item.id,
                                                        };
                                                    })
                                                    .slice(0, 10)
                                            )
                                        }
                                        onChange={(selected) => {
                                            if (selected) {
                                                setDealObject({
                                                    ...dealObject,
                                                    partner: selected.value,
                                                    partnerName: selected.label,
                                                    partnerUserId: selected.value,
                                                });
                                            } else {
                                                setDealObject({
                                                    ...dealObject,
                                                    partnerName: "",
                                                    partnerUserId: "",
                                                    partner: "",
                                                });
                                            }
                                        }}
                                        defaultOptions
                                        value={
                                            dealObject.partner
                                                ? {
                                                      label: dealObject.partnerName,
                                                      value: dealObject.partnerUserId,
                                                  }
                                                : ""
                                        }
                                        placeholder="Select Partner"
                                        isClearable={true}
                                    />
                                    <div>
                                        <ButtonWithText
                                            variant="l3rnTech"
                                            size="small"
                                            buttonStyle="borderless"
                                            onClick={() =>
                                                setDealObject({
                                                    ...initialDealObject,
                                                    newInquiry: true,
                                                    selectedInquiry: null,
                                                    // ...INHOUSE_DEAL_OBJECT,
                                                    closingDate: moment().valueOf(),
                                                    dealCampaignType: dealObject?.dealCampaignType,
                                                    dealPotential: dealObject?.dealPotential,
                                                    status: dealObject?.status,
                                                })
                                            }
                                            style={{ marginTop: "8px", padding: "0", height: "24px" }}
                                        >
                                            Or Create a New Inquiry
                                        </ButtonWithText>
                                    </div>
                                    {dealObject.status === DEAL_WON && (
                                        <div>
                                            <StyledLabel>Upload Document</StyledLabel>
                                            <ExtensionDealAttachments maxFiles={5} />
                                        </div>
                                    )}
                                </>
                            )}
                            {!dealObject.selectedInquiry && (
                                <>
                                    {/* dealObject.selectedInquiry yok */}
                                    <ButtonWithLabel
                                        variant="l3rnTech"
                                        buttonStyle="default"
                                        size="circle"
                                        icon={"add"}
                                        iconType={"material"}
                                        label={"Create New Inquiry"}
                                        onClick={() =>
                                            setDealObject({
                                                ...dealObject,
                                                selectedInquiry: null,
                                                newInquiry: true,
                                            })
                                        }
                                    />
                                </>
                            )}
                        </>
                    )}
                    {/* 1.2: newInquiry true: yeni deal oluşturulacak. */}
                    {dealObject.newInquiry && (
                        <>
                            {/* newInquiry true: yeni deal oluşturulacak. */}
                            {!emptyInhouseInquiries && (
                                <div>
                                    <ButtonWithText
                                        variant="l3rnTech"
                                        size="small"
                                        buttonStyle="borderless"
                                        onClick={() => setDealObject({ ...dealObject, newInquiry: false })}
                                        style={{ padding: "0", height: "24px" }}
                                    >
                                        Or Select Existing Inquiry
                                    </ButtonWithText>
                                </div>
                            )}
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Unit Amount USD"
                                type="input"
                                inpType="number"
                                leftIcon="dollar-sign"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("amount", value);
                                }}
                                value={dealObject.amount}
                                minLength={1}
                                placeholder="Enter Unit Amount"
                            />
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Partner"
                                type="select"
                                loadOptions={(input, callback) =>
                                    callback(
                                        companyUsers
                                            .filter((user) => user.name.toLowerCase().includes(input.toLowerCase()))
                                            .map((item) => {
                                                return {
                                                    label: item.name,
                                                    value: item.id,
                                                };
                                            })
                                            .slice(0, 10)
                                    )
                                }
                                onChange={(selected) => {
                                    if (selected) {
                                        setDealObject({
                                            ...dealObject,
                                            partner: selected.value,
                                            partnerName: selected.label,
                                            partnerUserId: selected.value,
                                        });
                                    } else {
                                        setDealObject({
                                            ...dealObject,
                                            partnerName: "",
                                            partnerUserId: "",
                                            partner: "",
                                        });
                                    }
                                }}
                                defaultOptions
                                value={
                                    dealObject.partner
                                        ? {
                                              label: dealObject.partnerName,
                                              value: dealObject.partnerUserId,
                                          }
                                        : ""
                                }
                                placeholder="Select Partner"
                                isClearable={true}
                            />
                            {dealObject.dealCampaignType === "L&D Broker" && (
                                <>
                                    <ExtensionInputGroup
                                        label="Amount for Vendor Payment"
                                        type="input"
                                        inpType="number"
                                        leftIcon="dollar-sign"
                                        onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("vendorPaymentAmount", value);
                                        }}
                                        value={dealObject.vendorPaymentAmount}
                                        minLength={1}
                                        placeholder="Enter amount for vendor payment"
                                        variant="l3rnTech"
                                    />
                                    <ExtensionInputGroup
                                        label="Margin amount for LEORON"
                                        type="input"
                                        inpType="number"
                                        leftIcon="dollar-sign"
                                        onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("leoronMarginAmount", value);
                                        }}
                                        value={dealObject.leoronMarginAmount}
                                        minLength={1}
                                        placeholder="Enter margin amount for LEORON"
                                        variant="l3rnTech"
                                    />
                                </>
                            )}

                            {dealObject.status === DEAL_WON && (
                                <>
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Set Closing Date"
                                        type="date"
                                        onChange={(date) => {
                                            handleInputChange("closingDate", date);
                                        }}
                                        value={dealObject.closingDate}
                                        placeholder="Select Closing Date"
                                        dateFormat={"dd/MM/yyyy"}
                                    />
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Type"
                                        type="select"
                                        options={dealMarketingTypesOptions}
                                        value={
                                            dealObject.type ? { label: dealObject.type, value: dealObject.type } : ""
                                        }
                                        onChange={(selected) => {
                                            handleInputChange("type", selected.value);
                                        }}
                                        placeholder="Select Type"
                                    />

                                    {(dealObject.type === "Marketing" ||
                                        dealObject.type === "Marketing Cross Sale") && (
                                        <ExtensionInputGroup
                                            variant="l3rnTech"
                                            label="Select Marketing Channel"
                                            type="select"
                                            options={dealChannelTypesOptions}
                                            value={
                                                dealObject.channelType
                                                    ? { label: dealObject.channelType, value: dealObject.channelType }
                                                    : ""
                                            }
                                            onChange={(selected) => {
                                                handleInputChange("channelType", selected.value);
                                            }}
                                            placeholder="Select Marketing Channel"
                                        />
                                    )}
                                    {dealObject.type === "Re-Seller Partnership" && (
                                        <ExtensionInputGroup
                                            label="End User"
                                            type="input"
                                            inpType="text"
                                            onChange={(e) => {
                                                const value = e.target ? e.target.value : e;
                                                handleInputChange("endUser", value);
                                            }}
                                            value={dealObject.endUser}
                                            placeholder="Please enter end user"
                                            minLength={1}
                                            variant="l3rnTech"
                                        />
                                    )}
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Paid Amount"
                                        type="input"
                                        min={0}
                                        minLength={1}
                                        inpType="number"
                                        leftIcon="dollar-sign"
                                        onKeyDown={(e) => {
                                            if (e.key === "-" || e.key === "e" || e.key === "+") {
                                                e.preventDefault();
                                            }
                                        }}
                                        onChange={(e) => {
                                            const value = e.target ? e.target.value : e;
                                            handleInputChange("paidAmount", value);
                                        }}
                                        value={dealObject.paidAmount}
                                        disabled={dealObject?.createAnotherDeal || dealObject?.toBe === DEAL_WON}
                                        placeholder="Enter Paid Amount"
                                    />
                                    <div className="d-flex align-items-center justify-content-between">
                                        <StyledToggleLabel>Vat Included</StyledToggleLabel>
                                        <Toggle
                                            variant="l3rnTech"
                                            setSelected={(value) => {
                                                handleInputChange("vatIncludes", value);
                                            }}
                                            selected={dealObject.vatIncludes}
                                            options={TOGGLE_OPTIONS}
                                        />
                                    </div>
                                    <div>
                                        <StyledLabel>Upload Document</StyledLabel>
                                        <ExtensionDealAttachments maxFiles={5} />
                                    </div>
                                </>
                            )}

                            {(dealObject.status === "Lost" || dealObject.status === "Cancelled") && (
                                <>
                                    <ExtensionInputGroup
                                        variant="l3rnTech"
                                        label="Set Closing Date"
                                        type="date"
                                        onChange={(date) => {
                                            handleInputChange("closingDate", date);
                                        }}
                                        value={dealObject.closingDate}
                                        placeholder="Select Closing Date"
                                        dateFormat={"dd/MM/yyyy"}
                                    />
                                </>
                            )}
                        </>
                    )}
                </>
            )}
            {/* 2. senaryo activityID var. started */}
            {dealObject.activityId && (
                <>
                    {dealObject?.toBe === DEAL_WON && (
                        <>
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Deal Name"
                                type="input"
                                inpType="text"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("ad", value);
                                }}
                                value={dealObject.ad}
                                placeholder="Enter Deal Name"
                            />

                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label={courseNameLabel}
                                type="select"
                                inpType="text"
                                onChange={(selected) => {
                                    handleInputChange("courseName", selected.value);
                                }}
                                options={courseNameOptions}
                                value={
                                    dealObject.courseName
                                        ? dealObject.courseName === "newCourseName"
                                            ? { label: "Type a new " + courseNameLabel, value: "newCourseName" }
                                            : { label: dealObject.courseName, value: dealObject.courseName }
                                        : ""
                                }
                                placeholder={`Select ${courseNameLabel}`}
                            />

                            {dealObject?.courseName === "newCourseName" && (
                                <ExtensionInputGroup
                                    variant="l3rnTech"
                                    label={`New ${courseNameLabel}`}
                                    type="input"
                                    inpType="text"
                                    onChange={(e) => {
                                        const value = e.target ? e.target.value : e;
                                        handleInputChange("newCourseName", value);
                                    }}
                                    value={dealObject.newCourseName}
                                    placeholder={`Enter ${newCourseNameLabel}`}
                                />
                            )}

                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Account Name"
                                type="input"
                                inpType="text"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("accountName", value);
                                }}
                                value={dealObject.accountName}
                                placeholder="Enter Account Name"
                            />

                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Unit Amount USD"
                                type="input"
                                inpType="number"
                                leftIcon="dollar-sign"
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("amount", value);
                                }}
                                value={dealObject.amount}
                                placeholder="Enter Unit Amount"
                            />

                            <div>
                                <StyledLabel>Number of Units</StyledLabel>
                                <div style={{ display: "flex", gap: "16px", marginTop: "4px" }}>
                                    <ButtonWithText
                                        label="Decrease"
                                        icon="remove"
                                        onClick={() => {
                                            const currentValue = Number(dealObject.numberOfUnits) || 1;
                                            if (currentValue > 1) {
                                                handleInputChange("numberOfUnits", currentValue - 1);
                                            }
                                        }}
                                        iconType="material"
                                        variant="passive"
                                        buttonStyle="default"
                                        size="circle"
                                    />
                                    {dealObject.numberOfUnits}
                                    <ButtonWithText
                                        label="Increase"
                                        icon="add"
                                        onClick={() => {
                                            const currentValue = Number(dealObject.numberOfUnits) || 0;
                                            handleInputChange("numberOfUnits", currentValue + 1);
                                        }}
                                        iconType="material"
                                        variant="l3rnTech"
                                        buttonStyle="default"
                                        size="circle"
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {dealObject?.toBe !== DEAL_WON && (
                        <ExtensionInputGroup
                            variant="l3rnTech"
                            label="Unit Amount USD"
                            type="input"
                            inpType="number"
                            leftIcon="dollar-sign"
                            onChange={(e) => {
                                const value = e.target ? e.target.value : e;
                                handleInputChange("amount", value);
                            }}
                            value={dealObject.amount}
                            minLength={1}
                            placeholder="Enter Unit Amount"
                        />
                    )}
                    <ExtensionInputGroup
                        variant="l3rnTech"
                        label="Partner"
                        type="select"
                        loadOptions={(input, callback) =>
                            callback(
                                companyUsers
                                    .filter((user) => user.name.toLowerCase().includes(input.toLowerCase()))
                                    .map((item) => {
                                        return {
                                            label: item.name,
                                            value: item.id,
                                        };
                                    })
                                    .slice(0, 10)
                            )
                        }
                        onChange={(selected) => {
                            if (selected) {
                                setDealObject({
                                    ...dealObject,
                                    partner: selected.value,
                                    partnerName: selected.label,
                                    partnerUserId: selected.value,
                                });
                            } else {
                                setDealObject({ ...dealObject, partnerName: "", partnerUserId: "", partner: "" });
                            }
                        }}
                        defaultOptions
                        value={
                            dealObject.partner
                                ? {
                                      label: dealObject.partnerName,
                                      value: dealObject.partnerUserId,
                                  }
                                : ""
                        }
                        placeholder="Select Partner"
                        isClearable={true}
                    />
                    {dealObject.dealCampaignType === "L&D Broker" && (
                        <>
                            <ExtensionInputGroup
                                label="Amount for Vendor Payment"
                                type="input"
                                inpType="number"
                                leftIcon="dollar-sign"
                                onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("vendorPaymentAmount", value);
                                }}
                                value={dealObject.vendorPaymentAmount}
                                minLength={1}
                                placeholder="Enter amount for vendor payment"
                                variant="l3rnTech"
                            />
                            <ExtensionInputGroup
                                label="Margin Amount for LEORON"
                                type="input"
                                inpType="number"
                                leftIcon="dollar-sign"
                                onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("leoronMarginAmount", value);
                                }}
                                value={dealObject.leoronMarginAmount}
                                minLength={1}
                                placeholder="Enter margin amount for LEORON"
                                variant="l3rnTech"
                            />
                        </>
                    )}

                    {dealObject.status === DEAL_WON && (
                        <>
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Set Closing Date"
                                type="date"
                                onChange={(date) => {
                                    handleInputChange("closingDate", date);
                                }}
                                value={dealObject.closingDate}
                                placeholder="Select Closing Date"
                                dateFormat={"dd/MM/yyyy"}
                            />
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Type"
                                type="select"
                                options={dealMarketingTypesOptions}
                                value={dealObject.type ? { label: dealObject.type, value: dealObject.type } : ""}
                                onChange={(selected) => {
                                    handleInputChange("type", selected.value);
                                }}
                                placeholder="Select Type"
                            />

                            {(dealObject.type === "Marketing" || dealObject.type === "Marketing Cross Sale") && (
                                <ExtensionInputGroup
                                    variant="l3rnTech"
                                    label="Select Marketing Channel"
                                    type="select"
                                    options={dealChannelTypesOptions}
                                    value={
                                        dealObject.channelType
                                            ? { label: dealObject.channelType, value: dealObject.channelType }
                                            : ""
                                    }
                                    onChange={(selected) => {
                                        handleInputChange("channelType", selected.value);
                                    }}
                                    placeholder="Select Marketing Channel"
                                />
                            )}
                            {dealObject.type === "Re-Seller Partnership" && (
                                <ExtensionInputGroup
                                    label="End User"
                                    type="input"
                                    inpType="text"
                                    onChange={(e) => {
                                        const value = e.target ? e.target.value : e;
                                        handleInputChange("endUser", value);
                                    }}
                                    value={dealObject.endUser}
                                    placeholder="Please enter end user"
                                    minLength={1}
                                    variant="l3rnTech"
                                />
                            )}
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Paid Amount"
                                type="input"
                                min={0}
                                minLength={1}
                                inpType="number"
                                leftIcon="dollar-sign"
                                onKeyDown={(e) => {
                                    if (e.key === "-" || e.key === "e" || e.key === "+") {
                                        e.preventDefault();
                                    }
                                }}
                                onChange={(e) => {
                                    const value = e.target ? e.target.value : e;
                                    handleInputChange("paidAmount", value);
                                }}
                                value={dealObject.paidAmount}
                                disabled={dealObject?.createAnotherDeal || dealObject?.toBe === DEAL_WON}
                                placeholder="Enter Paid Amount"
                            />
                            <div className="d-flex align-items-center justify-content-between">
                                <StyledToggleLabel>Vat Included</StyledToggleLabel>
                                <Toggle
                                    variant="l3rnTech"
                                    setSelected={(value) => {
                                        handleInputChange("vatIncludes", value);
                                    }}
                                    selected={dealObject.vatIncludes}
                                    options={TOGGLE_OPTIONS}
                                />
                            </div>
                        </>
                    )}

                    {(dealObject.status === "Lost" || dealObject.status === "Cancelled") && (
                        <>
                            <ExtensionInputGroup
                                variant="l3rnTech"
                                label="Set Closing Date"
                                type="date"
                                onChange={(date) => {
                                    handleInputChange("closingDate", date);
                                }}
                                value={dealObject.closingDate}
                                placeholder="Select Closing Date"
                                dateFormat={"dd/MM/yyyy"}
                            />
                        </>
                    )}
                </>
            )}
        </StyledContainer>
    );
};

export default ExtensionConsultingDeal;
